export class ExpenseType {
    id:number = 0;
    name:string = "";
    type:string = "";
    active:boolean = true;
    et_type_id: number = 0;
    et_type_name: string = '';
    apply_unit: boolean = true;
}
